// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AppCardComponent.css */
.app-card {
  margin: 10px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%; /* Make all cards the same height */
}

.app-card-header {
  background-color: #001f3f; /* Dark blue navy color */
  color: white;
  padding: 12px 16px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.app-card-title {
  font-size: 1.2rem;
  color: white;
  margin: 0;
  flex-grow: 1; /* Allow the title to take up available space */
}

.progress-indicator {
  flex-shrink: 0; /* Prevent the circle from shrinking */
  width: 40px;
  height: 40px;
}

.circular-chart {
  display: block;
  margin: 0 auto;
  max-width: 40px;
  max-height: 40px;
}

.circle-bg {
  fill: none;
  stroke: var(--ion-color-primary); /* Change this to the primary color */
  stroke-width: 3.8;
}

.circle {
  fill: none;
  stroke-width: 2.8;
  stroke-linecap: round;
  transition: stroke-dasharray 0.3s ease;
  stroke: #eee; /* Change this to the background color */
}

.percentage {
  fill: #dee;
  font-family: Arial, sans-serif;
  font-size: 0.75em;
  text-anchor: middle;
}

.app-card-content {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
}

.app-card-subtitle {
  font-size: 1rem;
  color: #666;
  margin-bottom: 12px;
}

.card-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.awsm-button {
  font-size: 1.2em;
  padding: 8px 12px;
}

.awsm-button ion-icon {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/Components/AppCardComponent.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY,EAAE,mCAAmC;AACnD;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;EACpD,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,YAAY,EAAE,+CAA+C;AAC/D;;AAEA;EACE,cAAc,EAAE,sCAAsC;EACtD,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gCAAgC,EAAE,qCAAqC;EACvE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sCAAsC;EACtC,YAAY,EAAE,wCAAwC;AACxD;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX","sourcesContent":["/* AppCardComponent.css */\n.app-card {\n  margin: 10px;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%; /* Make all cards the same height */\n}\n\n.app-card-header {\n  background-color: #001f3f; /* Dark blue navy color */\n  color: white;\n  padding: 12px 16px;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.app-card-title {\n  font-size: 1.2rem;\n  color: white;\n  margin: 0;\n  flex-grow: 1; /* Allow the title to take up available space */\n}\n\n.progress-indicator {\n  flex-shrink: 0; /* Prevent the circle from shrinking */\n  width: 40px;\n  height: 40px;\n}\n\n.circular-chart {\n  display: block;\n  margin: 0 auto;\n  max-width: 40px;\n  max-height: 40px;\n}\n\n.circle-bg {\n  fill: none;\n  stroke: var(--ion-color-primary); /* Change this to the primary color */\n  stroke-width: 3.8;\n}\n\n.circle {\n  fill: none;\n  stroke-width: 2.8;\n  stroke-linecap: round;\n  transition: stroke-dasharray 0.3s ease;\n  stroke: #eee; /* Change this to the background color */\n}\n\n.percentage {\n  fill: #dee;\n  font-family: Arial, sans-serif;\n  font-size: 0.75em;\n  text-anchor: middle;\n}\n\n.app-card-content {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex-grow: 1;\n}\n\n.app-card-subtitle {\n  font-size: 1rem;\n  color: #666;\n  margin-bottom: 12px;\n}\n\n.card-button-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.card-button-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.awsm-button {\n  font-size: 1.2em;\n  padding: 8px 12px;\n}\n\n.awsm-button ion-icon {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
